import React, { useState, useEffect, useCallback } from "react";
import { Grid, Message } from "semantic-ui-react";

import TopNav from "../../common/containers/top-nav";

import { makePrivateApiCall } from "utilities/dist/api";
import { CustomerBalanceDetails } from "../containers/balance";
import { isCompanyFeatureActive } from "utilities/dist/company/helpers";
import { CompanyFeatures } from "utilities/dist/company/constants";

const CustomerBalancePagePdf = ({ match }) => {
    const { token } = match.params;

    const [error, setError] = useState(null);
    const [customerBalance, setCustomerBalance] = useState(null);
    const [isLoading, setLoading] = useState(true);

    const loadCustomerBalance = useCallback(() => {
        makePrivateApiCall({
            url: `/pdf/customer/balance/${token}`,
        })
            .then(res => {
                setLoading(false);
                if (res.data) {
                    setCustomerBalance(res.data);
                    window.READY_FOR_PDF_EXPORT = true;
                    setError(null);
                }
            })
            .catch(err => {
                setLoading(false);
                setError(err.message);
            });
    }, [token]);

    const isCustomerInvoiceNumberingActive = customerBalance?.customer?.company
        ? isCompanyFeatureActive(
              customerBalance.customer.company,
              CompanyFeatures.CUSTOMER_INVOICE_NUMBERING
          )
        : false;
    // when a value change is requested, let's first make sure that the value is actually changing from the current value
    // if not, no point showing the modal window asking for confirmation, right?

    useEffect(() => {
        setLoading(true);
        loadCustomerBalance();
    }, []);

    if (!isLoading && error) {
        return <Message content={error} header="Sorry, something went wrong!" />;
    }

    return (
        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Grid>
                <TopNav
                    printSubheader
                    headerIcon="dollar sign"
                    subheader={customerBalance?.customer?.name || "Loading customer..."}
                    headerContent="Customer Balance"
                />
                <Grid.Row>
                    <Grid.Column width={16}>
                        {customerBalance && (
                            <CustomerBalanceDetails
                                {...{
                                    balanceInfo: customerBalance,
                                    isCustomerInvoiceNumberingActive,
                                }}
                            />
                        )}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    );
};

export default CustomerBalancePagePdf;
